import React from 'react';
import { useEffect, useState, useRef, useLayoutEffect } from 'react';
import Header from '../../components/header/header';
import './assessmentResults.css';
import { useHotkeys } from 'react-hotkeys-hook';
import { useNavigate } from 'react-router-dom';
import utilities from '../../utils/utils';
import connector from '../../connector/connector';
import content from '../../content/content';
import BannerImage from '../../components/bannerImage/bannerImage';
import JourneyStageSkeleton from '../../components/skeletons/journeyStage/journeyStage';
import exploratoryGraphic from '../../assets/readiness_stage_graphics/explore_line.png'
import developingGraphic from '../../assets/readiness_stage_graphics/dev_line.png';
import advancingGraphic from '../../assets/readiness_stage_graphics/adv_line.png';
import leadingGraphic from '../../assets/readiness_stage_graphics/lead_line.png';
import stagesGraphic from '../../assets/iconandtext.png';
import Footer from '../../components/footer/footer';
import RadarGraph from '../../components/radarGraph/radarGraph';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import config from '../../config/config';
import Modal from 'react-modal';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};


const AssessmentResults = () => {
    const [categoryScores, setCategoryScores] = useState(null);
    const [showSendEmailButton, setShowSendEmailButton] = useState(false);
    const [email, setEmail] = useState('');
    const [userEmailIsSaved, setUserEmailIsSaved] = useState(localStorage.getItem('userEmail') ? true : false);
    // const [emailResent, setEmailResent] = useState(localStorage.getItem('emailResent') ? true : false);
    const [strongestCategory, setStrongestCategory] = useState(null);
    const [readinessRating, setReadinessRating] = useState(null);
    const [readinessGraphic, setReadinessGraphic] = useState({ src: null, alt: '', classTitle: '' });
    const [showExpandedInfo, setShowExpandedInfo] = useState(localStorage.getItem('userEmail') ? true : false);
    const [bannerText, setBannerText] = useState(null);
    const [recommendationsData, setRecommendationsData] = useState([null]);
    // const [selectedRec, setSelectedRec] = useState(null);
    const radarParent = useRef();
    const [radarDimensions, setRadarDimensions] = useState({width: 0, height: 0});
    const [radarGraphData, setRadarGraphData] = useState({
        loaded: false,
        target: [
            { axis: 'Policy', value: 0 },
            { axis: 'People', value: 0 },
            { axis: 'Technology', value: 0 }
        ],
        median: [
            { axis: 'Policy', value: 0 },
            { axis: 'People', value: 0 },
            { axis: 'Technology', value: 0 }
        ],
        max: [
            { axis: 'Policy', value: 0 },
            { axis: 'People', value: 0 },
            { axis: 'Technology', value: 0 }
        ],
    });

    


    let subtitle;
    const [modalIsOpen, setIsOpen] = React.useState(false);

    // function openModal() {
    //     setIsOpen(true);
    // }

    function afterOpenModal() {
        // references are now sync'd and can be accessed.
        subtitle.style.color = '#f00';
    }

    function closeModal() {
        setIsOpen(false);
    }



    const pdfRef = useRef();

    const handleDownload = async () => {
        try {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
            setBannerText('You now have access to Journey Stage Insights and Recommendations. Your PDF download will begin shortly.');
            setTimeout(() => {
                setBannerText(null)
            }, 3000);
            const input = pdfRef.current;

            if (!input) {
                console.error('PDF reference element not found');
                return;
            }

            // Wait a bit for any dynamic content to load
            await new Promise(resolve => setTimeout(resolve, 5000));

            const canvas = await html2canvas(input, {
                scale: 2,
                useCORS: true,
                allowTaint: false,
                backgroundColor: '#ffffff',
                // foreignObjectRendering: true,
                onclone: (clonedDoc) => {
                  // Remove any gradients before rendering
                  clonedDoc.querySelectorAll('*').forEach(el => {
                    const bg = window.getComputedStyle(el).backgroundImage;
                    if (bg && bg.includes('gradient')) {
                      el.style.backgroundImage = 'none';
                      el.style.backgroundColor = '#fff'; // or a neutral fallback
                    }
                    // Also strip out SVG gradients if they exist
                    if (el.tagName === 'svg') {
                      el.querySelectorAll('linearGradient, radialGradient').forEach(g => g.remove());
                    }
                    if (el.classList && el.classList.contains('no-print')) {
                        el.style.display = 'none';
                    }
                  });
                }
              });

            // Verify canvas was created successfully
            if (!canvas || canvas.width === 0 || canvas.height === 0) {
                throw new Error('Failed to create canvas from element');
            }

            // Get the canvas data as data URL directly
            const imgData = canvas.toDataURL('image/png', 1.0);

            // Verify the data URL format
            if (!imgData.startsWith('data:image/png;base64,')) {
                throw new Error('Invalid image data format');
            }

            const pdf = new jsPDF('p', 'pt', 'a4');

            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();

            // Calculate dimensions to fit entire content on one page
            const imgWidth = pdfWidth;
            const imgHeight = (canvas.height * pdfWidth) / canvas.width;

            // If the image is taller than the page, scale it down to fit
            if (imgHeight > pdfHeight) {
                const scaleFactor = pdfHeight / imgHeight;
                const scaledWidth = imgWidth * scaleFactor;
                const scaledHeight = pdfHeight;

                // Center the image horizontally if it's scaled down
                const xOffset = (pdfWidth - scaledWidth) / 2;

                pdf.addImage(imgData, 'PNG', xOffset, 0, scaledWidth, scaledHeight);
            } else {
                // Center the image vertically if it's shorter than the page
                const yOffset = (pdfHeight - imgHeight) / 2;
                pdf.addImage(imgData, 'PNG', 0, yOffset, imgWidth, imgHeight);
            }

            pdf.save(`GovEx ${config.applicationName} Results.pdf`);

        } catch (error) {
            console.error('Error generating PDF:', error);
            alert('There was an error generating the PDF. Please try again.');
        }
    };

    const navigate = useNavigate();

    useEffect( () => {

        
       
            setTimeout(() => {
                setBannerText('You have successfully completed the assessment! Generating your results...');
            }, 1500);
    
            const fetchData = async () => {
                try {
                    const data = await connector.handleAssessmentSubmission(
                        localStorage.getItem('assessmentId'),
                        localStorage.getItem('userEmail')
                    );
    
                    localStorage.setItem('assessmentId', data.assessmentData.assessmentId);
    
                    // console.log('handleAssessmentSubmission data:', data);
    
                    const maximums = await connector.getCategoryMaximums();
                    if (!maximums || !Array.isArray(maximums) || maximums.some(m => !m.maxPoints)) {
                        console.error('Invalid maximums data:', maximums);
                        return;
                      }
                    const clampedMaximums = {
                        Policy: Math.min(data.scores.Policy, maximums.find(f => f.category === "Policy").maxPoints),
                        People: Math.min(data.scores.People, maximums.find(f => f.category === "People").maxPoints),
                        Technology: Math.min(data.scores.Technology, maximums.find(f => f.category === "Technology").maxPoints),
                    }          
                    setCategoryScores(clampedMaximums);
                    setStrongestCategory(Object.entries(data.scores).sort((a,b) => b[1] - a[1])[0][0]);
                    setRecommendationsData(data.scores.recommendations);
                    setRadarGraphData({
                        loaded: true,
                        target: [
                            { axis: 'Policy', value: clampedMaximums.Policy},
                            { axis: 'People', value: clampedMaximums.People},
                            { axis: 'Technology', value: clampedMaximums.Technology}
                        ],
                        median: [
                            { axis: 'Policy', value: data.totalsAndAverages.averages.policy },
                            { axis: 'People', value: data.totalsAndAverages.averages.people },
                            { axis: 'Technology', value: data.totalsAndAverages.averages.technology }
                        ],
                        max: [
                            { axis: 'Policy', value: maximums.find(f => f.category === "Policy").maxPoints },
                            { axis: 'People', value: maximums.find(f => f.category === "People").maxPoints },
                            { axis: 'Technology', value: maximums.find(f => f.category === "Technology").maxPoints }
                        ]
                    });
                    const maxPossible = maximums.reduce((acc,curr)=> acc + curr.maxPoints, 0)
                    const newTotal = Object.values(clampedMaximums).reduce((acc,curr)=> acc + curr,0);
                    setReadinessRating(calculateCategoryLevel((newTotal/maxPossible) * 100));
                    setReadinessGraphic(returnReadinessGraphic(calculateCategoryLevel((newTotal/maxPossible) * 100)));
                    setBannerText(null);
                    utilities.cleanupLocalStorage();
                } catch (error) {
                    console.error('Error in handleAssessmentSubmission:', error);
                    throw error;
                }
            };
    
            if (utilities.getAnsweredQuestionsCount() > 0) {
                fetchData();
                return;
            } else {
                // If no answered questions, redirect to assessment start page
    
                navigate('/assessment/policy');
    
            }
        

    }, [navigate]);

   
    const returnReadinessGraphic = (rating) => {
        // console.log("graphic", rating)
        switch (rating) {
            case 'Exploring': return { src: exploratoryGraphic, alt: 'Exploratory graphic', classTitle: 'exploratory-graphic' };
            case 'Developing': return { src: developingGraphic, alt: 'Developing graphic', classTitle: 'developing-graphic' };
            case 'Advancing': return { src: advancingGraphic, alt: 'Advancing graphic', classTitle: 'advancing-graphic' };
            case 'Leading': return { src: leadingGraphic, alt: 'Leading graphic', classTitle: 'leading-graphic' };
            default: return { src: null, alt: '', classTitle: '' };
        }
    }

    const navigateToSettings = () => {
        navigate('/settings');
    }

    useHotkeys('ctrl+shift+s', navigateToSettings)

    const handleEmailSubmission = () => {
        localStorage.setItem('userEmail', email);
        setShowSendEmailButton(false);
        setUserEmailIsSaved(true);
        setShowExpandedInfo(true);
        handleDownload();
        utilities.updateOrAddEmailToAssessment(localStorage.getItem('assessmentId'), email).then(() => { delete localStorage['userEmail'] }).catch((err) => { console.error(err); });
    };

    // const handleEmailResend = () => {
    //     setEmailResent(true);
    //     localStorage.setItem('emailResent', true)
    // }

    const calculateCategoryLevel = (percentage) => {
        let level = "";
        if (percentage <= 25) {
            level = "Exploring"
        } else if (percentage <= 50) {
            level = "Developing"
        } else if (percentage <= 75) {
            level = "Advancing"            
        } else if (percentage <= 100) {
            level = "Leading"            
        }
        // console.log(percentage, level)
        return level
    }
    useLayoutEffect(() => {
        const handleResize = () => {
            if (radarParent.current) {
                const rect = radarParent.current.getBoundingClientRect()
                setRadarDimensions({width: rect.width, height: rect.height})
            }
        }
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
        }
    },[radarParent])

    return (
        <>
        <div ref={pdfRef}>
        <div className='no-print'><Header bannerContent={bannerText}></Header></div>
        <BannerImage text={`${config.applicationName} | Results`}></BannerImage>
        <div className='page-container'>
            <div className="assessment-results">
                <div className='results-text-wrapper no-split'>
                    <p className='results-greeting no-print'>Congratulations! You have completed the survey. This assessment is designed to provide a snapshot of your organization’s journey towards AI adoption and identify success and opportunities that you may consider</p>
                    <p className='results-summary'>The summary includes an analysis of your city’s AI readiness and recommendations on how to advance your AI practice. You’re among the first to take this assessment and will set a baseline for other cities as they are invited to take it in the coming weeks and months. As more cities take this assessment, participants will have a comparative look at how they fare, and the median on the radar chart (shown below) will shift. Unique to this assessment, you will see where you stand compared to other cities.</p>
                    <p className='results-summary'>The {config.applicationName} was designed to focus specifically on three strategic topics for advancing AI in your city: <span>Policy</span>, <span>People</span>, and <span>Technology</span>.</p>
                </div>
                <div className="pdf-break"></div>
                <div className="html2pdf__page-break" />
                <div className='results-two-wrapper'>
                    <div className={showExpandedInfo ? 'results-two-inner-wrapper-expanded' : 'results-two-inner-wrapper'}>

                         {readinessRating ? <div className={showExpandedInfo ? 'journey-stage-wrapper-expanded' : 'journey-stage-wrapper'}>
                        <div className='cities-comparison-color-banner' style={{ borderTopLeftRadius: '8px', borderTopRightRadius: '8px' }}>Journey Stage</div>
                        <div className='journey-stage-content-wrapper'>
                            <div className='journey-stage-text-wrapper'>

                                <h4>You are in the {readinessRating} Stage!</h4>
                                <p>{`We’ve used your responses to place your city within one of four stages of the maturity framework and your overall competency across four categories: data, policy, people, and technology. Based on your responses, your city is in the ${readinessRating} Stage.`}</p>
                                <p>The people-process-technology framework is a decades-old approach to managing and evaluating organizational change, and we believe it is just as relevant today as ever (although we’re using the term “policy” instead of “process”). All three components are equally important in determining an organization’s adaptability and measuring progress.</p>
                                
                            </div>
                            <div className='journey-stage-image-wrapper'>
                                <div className='journey-stage-background-image'>
                                    <img src={readinessGraphic.src} alt={readinessGraphic.alt} className={readinessGraphic.classTitle}></img>
                                </div>
                            </div>
                        </div>
                    </div> : <JourneyStageSkeleton></JourneyStageSkeleton>}

                    {showExpandedInfo && <div className='stages-outer-wrapper'>
                            <img src={stagesGraphic} alt='Stages graphic' className='stages-graphic'></img>
                        </div>}
                    </div>
                   
                </div>
                <div className="pdf-break"></div>
                <div className="html2pdf__page-break" />
                <div className='results-three-wrapper no-split'>
                    <div className='category-breakdown-wrapper no-split'>
                        <div className='category-breakdown-color-banner'>Results Breakdown by Category</div>
                        <div className='category-scores-bars'>
                            {radarGraphData.loaded && categoryScores && Object.entries(categoryScores).map(([category, score]) => (
                                <div key={category} className='category-score-row'>
                                    <h4 className='category-score-label'>{category}</h4>
                                    <div className='outer-progress-bar-wrapper'>
                                    {categoryScores[category] > 0 ? (
                                        <div className='category-score-bar-fill' style={{ width: `${utilities.calculatePercentage(categoryScores[category], radarGraphData.max.find(f => f.axis === category).value)}%` }}>
                                            <div className='category-score-bar-text'>{`${utilities.calculatePercentage(categoryScores[category], radarGraphData.max.find(f => f.axis === category).value)}%`}</div>
                                        </div>
                                    ) : (
                                        <div className='category-score-bar-text zero-score'>0%</div>
                                    )}
                                    </div>
                                </div>
                            ))}
                            {!categoryScores && <tbody><tr><td colSpan="2">Loading scores...</td></tr></tbody>}
                            {categoryScores && Object.keys(categoryScores).length === 0 && <tbody><tr><td colSpan="2">No scores available.</td></tr></tbody>}
                        </div>
                        <div className='category-descriptions-wrapper no-split'>
                            {strongestCategory && <p>You are strongest in {strongestCategory}</p>}
                            {
                                content.categoryDescriptions && Object.entries(content.categoryDescriptions).map(([category, description]) => (
                                    <div key={category}>
                                        <h4>{category.charAt(0).toUpperCase() + category.slice(1) + ':'}</h4>
                                        <p>{description}</p>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    <div className='cities-comparison-wrapper no-split'>
                        <div className='cities-comparison-color-banner'>How Your City Compares to Others</div>
                        {/* <h2>How your city compares to others</h2> */}
                        <div className='radar-graph-wrapper no-split'>
                            <div ref={radarParent} className='radar-graph-parent'>
                                {radarDimensions.width > 0 &&
                                    <RadarGraph data={radarGraphData} size={radarDimensions}></RadarGraph>
                                }
                                <div className='radar-graph-legend'>
                                    <div className='radar-graph-legend-entry'>
                                        <div className='radar-graph-legend-entry-swatch'
                                            style={{backgroundColor: "#A15A95", border: "2px solid #A15A95"}}
                                        ></div>
                                        <div className='radar-graph-legend-entry-label'>Your City</div>
                                    </div>
                                    <div className='radar-graph-legend-entry'>
                                        <div className='radar-graph-legend-entry-swatch'
                                            style={{border: "2px solid #37848f"}}
                                        ></div>
                                        <div className='radar-graph-legend-entry-label'>Median</div>
                                    </div>
                                </div>
                            </div>
                            <div className='graph-categories-wrapper'>
                                {categoryScores ? <ul>
                                    <li>
                                        <div>
                                            <h6>POLICY</h6>
                                            <p>{calculateCategoryLevel(utilities.calculatePercentage(categoryScores.Policy, radarGraphData.max.find(f => f.axis === "Policy").value))}</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div>
                                            <h6>PEOPLE</h6>
                                            <p>{calculateCategoryLevel(utilities.calculatePercentage(categoryScores.People, radarGraphData.max.find(f => f.axis === "People").value))}</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div>
                                            <h6>TECHNOLOGY</h6>
                                            <p>{calculateCategoryLevel(utilities.calculatePercentage(categoryScores.Technology, radarGraphData.max.find(f => f.axis === "Technology").value))}</p>
                                        </div>
                                    </li>
                                </ul> : 'Loading scores...'}
                            </div>
                        </div>
                        <p>Each assessment topic—People, Policy, and Technology—has also been assigned a specific stage: Early Stage, Developing, or Advanced. Areas marked as “Early Stage” or “Developing” highlight opportunities to strengthen your city’s AI practice”
                        </p>
                    </div>
                </div>
                <div className="pdf-break"></div>
                <div className="html2pdf__page-break" />
                {showExpandedInfo && <div className='expanded-recs-outer-wrapper    '>
                    <div className='recs-inner'>
                        <div className='recs-inner-color-banner'>Recommendations</div>
                        {/* <h2>Recommendations</h2> */}
                        <p>Each assessment topic–Data, Policy, People, and Technology–has also been assigned a specific stage: Early Stage, Developing, or Advanced. Areas marked as ‘Early Stage’ or ‘Developing’ highlight opportunities to strengthen your city’s AI practice.

                        </p>

                        <ul>
                            {
                                recommendationsData && recommendationsData.map((rec, index) => (
                                    <li key={index}
                                    //  onClick={() => {
                                    //     setSelectedRec(recommendationsData[index]);
                                    //     console.log(selectedRec)
                                    //     openModal();}
                                    // }
                                    >{rec.title}</li>
                                ))
                            }
                        </ul>
                    </div>

                </div>}
                {!userEmailIsSaved ? <div className='results-email-wrapper no-print'>
                    <p>To receive a PDF version of this report with a list of recommendations based on your response to the assessment, please enter your email address below.</p>
                    <p className='disclaimer'>By clicking to access your report, you agree to receive communication from GovEx and consent to allow the Bloomberg Center for Government Excellence (GovEx) to store and process the personal information submitted above.</p>
                    <input type="email" placeholder={categoryScores ? 'Enter email address' : 'Results loading...'} className='email-input' value={email} onChange={(e) => {
                        setEmail(e.target.value);
                        if (utilities.isValidEmail(e.target.value)) {
                            setShowSendEmailButton(true);
                        } else {
                            setShowSendEmailButton(false);
                        }
                    }} disabled={!categoryScores} />
                    <br></br>
                    {/* {userEmailIsSaved && <button className={emailResent ? 'disabled-btn' : ''} onClick={handleEmailResend}>{emailResent ? 'Email resend limit reached' : `Resend full report to ${localStorage.getItem('userEmail')}`}</button>} */}
                    {showSendEmailButton && <button className='btn-send-email' onClick={handleEmailSubmission}>Access your full report</button>}

                    <p>Please note that assessments that meet our threshold for completion will be included in the collection of responses used to calculate the median.
                    </p>
                    {/* <button className='feedback-btn'>Submit Feedback</button> */}
                </div> : <button className='download-pdf-btn no-print' onClick={handleDownload}>Download results as PDF</button>}                
            </div>
            </div>
            <Footer showFeedbackLink={true}></Footer>
            </div>
            <p className='feedback-tab'><a href='https://form.asana.com/?k=4XWA1HSIKdmMfB9GZZVNmA&d=1108016200678557' target='_blank' rel="noreferrer">Submit Feedback</a></p>
            <Modal
                isOpen={modalIsOpen}
                onAfterOpen={afterOpenModal}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <h2 ref={(_subtitle) => (subtitle = _subtitle)}>Hello</h2>
                <button onClick={closeModal}>close</button>
                {/* <div>{selectedRec.recommendation.title}</div> */}
                <form>
                    <input />
                    {/* <button>{selectedRec.recommendation.title}</button> */}
                    <button>stays</button>
                    <button>inside</button>
                    <button>the modal</button>
                </form>
            </Modal>
        </>            
        );
};

export default AssessmentResults;